import { FieldError, useFieldError } from '@wkda/funnel-components';
import cx from 'classnames';
import { baseFieldRenderer } from './fieldRenderers/baseFieldRenderer';
import { useTrackInputActivation } from './hooks/useTrackInputActivation';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function BaseField(_ref) {
  let {
    label,
    name,
    MktSelector,
    topContainerClassName,
    infoText,
    renderHeader = function renderHeader(_ref2) {
      let {
        label,
        name,
        headerClassName,
        ...props
      } = _ref2;
      return /*#__PURE__*/_jsx(BaseFieldHeader, {
        name: name,
        label: label,
        className: headerClassName,
        ...props
      });
    },
    renderFieldComponent = baseFieldRenderer,
    renderError = function renderErrorField(name) {
      return /*#__PURE__*/_jsx(FieldError, {
        name: name
      });
    },
    renderInfoText = function renderInfoTextComponent(text) {
      return Boolean(text) ? /*#__PURE__*/_jsx("span", {
        className: "font-size-xs d-block mt-1 text-muted",
        children: text
      }) : null;
    },
    renderContentBelow = function renderContentBelowCompont(_ref3) {
      let {
        name,
        text
      } = _ref3;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [renderError(name), renderInfoText(text)]
      });
    },
    renderFieldWrapper = renderFieldSideWrapper,
    disabled,
    onFieldEnabled,
    isHiddenField = false,
    ...props
  } = _ref;
  const fieldName = `field-${name}`;
  const fieldHasError = useFieldError(name);
  useTrackInputActivation(name, !disabled, onFieldEnabled);
  const hasError = !disabled && fieldHasError;
  return /*#__PURE__*/_jsx("div", {
    id: fieldName,
    "data-mkt-selector": MktSelector?.value,
    "data-qa-selector": MktSelector?.value,
    className: cx('carlead-creation-field-container', `carlead-creation-field-container--${name}`, {
      'carlead-creation-field-container--is-hidden': isHiddenField === true && disabled,
      'carlead-creation-field-container--has-error': hasError
    }, topContainerClassName),
    children: renderFieldWrapper({
      fieldRenderer: renderFieldComponent,
      headerRenderer: renderHeader,
      mktSelector: MktSelector,
      belowRenderer: renderContentBelow,
      label,
      infoText,
      disabled,
      name,
      extraProps: {
        'aria-invalid': hasError ? true : undefined,
        'aria-describedby': hasError ? `${name}-error` : undefined,
        ...props
      }
    })
  });
}
export function BaseFieldHeader(_ref4) {
  let {
    label,
    name,
    className
  } = _ref4;
  return /*#__PURE__*/_jsx("label", {
    className: cx('carlead-creation-field__label', className),
    htmlFor: name,
    children: label
  });
}
export function renderFieldSideWrapper(_ref5) {
  let {
    fieldRenderer,
    headerRenderer,
    belowRenderer,
    label,
    infoText,
    extraProps,
    name,
    ...props
  } = _ref5;
  return /*#__PURE__*/_jsxs("div", {
    className: "carlead-creation-field carlead-creation-field-horizontal",
    children: [/*#__PURE__*/_jsx("div", {
      className: "carlead-creation-field-horizontal__header",
      children: headerRenderer({
        label,
        name,
        headerClassName: 'carlead-creation-field-horizontal__label'
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "carlead-creation-field__group carlead-creation-field-horizontal__group",
      children: [fieldRenderer({
        name,
        ...extraProps,
        ...props
      }), belowRenderer({
        name,
        text: infoText
      })]
    })]
  });
}
export function renderFieldVerticalWrapper(_ref6) {
  let {
    fieldRenderer,
    headerRenderer,
    label,
    infoText,
    belowRenderer,
    extraProps,
    name,
    ...props
  } = _ref6;
  return /*#__PURE__*/_jsxs("div", {
    className: "carlead-creation-field",
    children: [headerRenderer({
      label,
      name
    }), /*#__PURE__*/_jsxs("div", {
      className: "carlead-creation-field__group",
      children: [fieldRenderer({
        name,
        ...extraProps,
        ...props
      }), belowRenderer({
        name,
        text: infoText
      })]
    })]
  });
}
export function renderBareFieldWrapper(_ref7) {
  let {
    fieldRenderer,
    infoText,
    belowRenderer,
    extraProps,
    name,
    ...props
  } = _ref7;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fieldRenderer({
      name,
      ...extraProps,
      ...props
    }), belowRenderer({
      name,
      text: infoText
    })]
  });
}